const api_prefix = "/api/";
const ws_prefix = "/ws/";

const api_urls = {
    user: "user",
    login: "user/login",
    logout: "user/logout",
    signup: "user/signup",
    unregister: "user/withdraw",
    emailConfirm: "user/email/confirm",
    resetPassword: "user/reset/password",
    changePassword: "user/change/password",
    changeMarketing: "user/change/marketing",
    changeEnvSettings: "user/change/env-settings",
    googleLogin: "user/social/google/",
    naverLogin: "user/social/naver/",
    adminChangeUser: "user/admin/change/user",
    exitSurvey: "user/survey/WITHDRAWAL_SURVEY",

    researchOrder: "paper/research/order",
    referenceResearch: "paper/reference/research",
    referenceCitation: "paper/reference/research/citation",

    researchMedia: "paper/research/media",
    researchCreateWidthHtml: "paper/researches/convert-html",
    selectBoxOptions: "common/select-box-options",

    // payment
    paymentBillingKey: "payment/billing/key",
    paymentPlan: "payment/plan",
    paymentCoupon: "payment/coupon",
    paymentCouponRegister: "payment/coupon/register",
    paymentDiscountPolicy: "payment/discount/policy",

    // papers
    paperSearch: "paper/papers/search",
    referenceFile: "paper/reference/file",
    paperAddWithBibtex: "paper/reference/add-with-bibtex",
    referenceAddFromSource: "paper/reference/add-from-source",
    paperRecommendation: "paper/papers/recommendation",
    paperDetail: "paper/papers/detail",
    paperRelatedPapers: "paper/papers/related-papers",
    paperStyle: "paper/papers/style",
    paperSearchHistory: "paper/search/history",

    // review
    review: "review",

    // space
    space: "space",
    volume: "user/volume",
    bibliography: "paper/reference",
    research: "paper/research",
    manuscript: "manuscript",
    manuscriptTemplate: "manuscript/template",
    tag: "paper/tag",
    folder: "paper/folder",
    researchAnalysis: "paper/researches/analysis",
};

const sse_url = {
    ssePaperSummarize: "sse/paper/summarize",
};

const ws_urls = {
    review: "review",
    search: "search",
    researchAnalysisConsumer: "research/analysis/consumer",
    referenceAnalysis: "reference/analysis",
    researchContentGenerator: "research/content/generate",
};

export function apiUrl(url) {
    return window.location.protocol + "//" + process.env.REACT_APP_API_BASE_URL + api_prefix + api_urls[url];
}

export function apiSpaceUrl(url, spaceUuid) {
    if (!spaceUuid) {
        throw new Error("spaceUuid is required");
    }
    return (
        window.location.protocol +
        "//" +
        process.env.REACT_APP_API_BASE_URL +
        api_prefix +
        `space/${spaceUuid}/` +
        api_urls[url]
    );
}

export function sseUrl(url) {
    return window.location.protocol + "//" + process.env.REACT_APP_API_BASE_URL + api_prefix + sse_url[url];
}

export function wsUrl(url) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        ws_urls[url] +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptDocumentUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptEventUrl(spaceUuid, manuscriptId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptAIEditUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}/ai-edit` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptMathOCRUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}/math-ocr` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptLatexErrorFixUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}/latex-error-fix` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptReviewAIUrl(spaceUuid, manuscriptId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/review-ai` +
        `?token=${localStorage.getItem("token")}`
    );
}
